// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__34jSQ","cell":"ColumnAccessor_cell__3O6WK","firstCellAccent":"ColumnAccessor_firstCellAccent__L2Z50"};